import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { jobChoices } from '../api/jobs'
import { useSession } from '../session'
import HelpTip from './HelpTip'

/** The job a quote, invoice, bill or expense belongs to. Shows only once
    the company has a job, so a shop that never uses jobs sees nothing. With
    a customer, only that customer's jobs (and jobs without one) are offered,
    and a job for someone else is cleared. */
export default function JobSelect({ customerId, value, onChange, disabled, className = 'ci-form-field' }) {
  const { has } = useSession()
  const [jobs, setJobs] = useState(null)
  const on = has('jobs')

  useEffect(() => {
    if (!on) return undefined
    let cancelled = false
    jobChoices({ customerId, include: value || undefined })
      .then((rows) => { if (!cancelled) setJobs(Array.isArray(rows) ? rows : []) })
      .catch(() => { if (!cancelled) setJobs([]) })
    return () => { cancelled = true }
  }, [on, customerId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!jobs || disabled || !value) return
    if (!jobs.some((j) => String(j.job_id) === String(value))) onChange('')
  }, [jobs]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!on || !jobs || (!jobs.length && !value)) return null
  return (
    <label className={className}>
      <span>
        Job (optional) <HelpTip text="The piece of work this is for, such as “Smith bathroom”. The job page adds up what it earned and cost." />
        {value && <> · <Link to={`/jobs/${value}`}>Open job</Link></>}
      </span>
      <select disabled={disabled} value={value || ''} onChange={(e) => onChange(e.target.value)}>
        <option value="">No job</option>
        {jobs.map((j) => (
          <option key={j.job_id} value={j.job_id}>{j.label}{j.status !== 'Open' ? ` (${j.status.toLowerCase()})` : ''}</option>
        ))}
      </select>
    </label>
  )
}
